module.exports = __webpack_public_path__ + "img/Plantas Manejadas para Controle do Cancro Europeu - Cirurgia 1.1e88e91f.webp";